module.exports = __webpack_public_path__ + "static/Gelatinous_Cube-0781c3bab9e9f538b871bf9909233938.jpg";